import { __awaiter } from "tslib";
import Vue from 'vue';
import { BuddyInnerStatus, BuddyProgress, BuddyStatus, InfoBlock, StagesNames } from '../../index.vue';
import { ActivePopupTypes } from '@whitelist/wl-old-library/components/global/types';
import BigNumber from 'bignumber.js';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'buddyAsideWidget',
    data: () => {
        return {
            buddyApiKey: '',
            buddySecretKey: '',
            copiedApiKey: false,
            copiedSecretApiKey: false,
            apiKeyExist: false
        };
    },
    props: {
        agreementChecked: {
            type: Boolean,
            required: true
        },
        innerStatus: {
            type: String,
            required: true
        },
        isInnerStatusHideApikey: {
            type: Boolean,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        currentStage: {
            type: String,
            required: true
        },
        sqStatus: {
            type: String,
            required: true
        },
        currentSq: {
            type: String,
            required: true
        },
        testingStatus: {
            type: String,
            required: true
        },
        sqLowerThanAcceptable: {
            type: Boolean,
            required: true
        },
        info: {
            type: String,
            required: true
        },
        updateDataFn: {
            type: Function,
            required: true
        },
        sqBorder: {
            type: BigNumber,
            required: true
        }
    },
    methods: {
        agreementHandler(value) {
            this.$emit('agreementHandler', value);
        },
        plugBuddy() {
            const self = this;
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('buddyPage.popups.titles.createApiKey'),
                slot: {
                    name: 'buddyApiKeysCreate',
                    data: {
                        updateDataFn: self.updateDataFn
                    }
                }
            });
        },
        copyApiKey() {
            navigator.clipboard.writeText(this.buddyApiKey);
            this.copiedApiKey = true;
            setTimeout(() => {
                this.copiedApiKey = false;
            }, 3000);
        },
        copyApiKeySecret() {
            navigator.clipboard.writeText(this.buddySecretKey);
            this.copiedSecretApiKey = true;
            setTimeout(() => {
                this.copiedSecretApiKey = false;
            }, 3000);
        },
        getApiKeyInfo() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield this.services.v2.trade.buddyKeyInfo();
                if (response.status === 200) {
                    this.apiKeyExist = true;
                    this.buddyApiKey = response.data.payload.api;
                    this.buddySecretKey = response.data.payload.secret;
                }
            });
        }
    },
    computed: {
        showCurrentSq() {
            if (this.innerStatus === BuddyInnerStatus.api || this.innerStatus === BuddyInnerStatus.noData)
                return false;
            return this.sqStatus === BuddyProgress.success || BigNumber(this.currentSq).gt(0);
        },
        sqIcon() {
            const isAnalyzing = this.info === InfoBlock.apiCreatedAnalyzing;
            let result = '';
            switch (this.sqStatus) {
                case BuddyProgress.notStarted:
                    result = 'question';
                    break;
                case BuddyProgress.process:
                    result = isAnalyzing ? 'question' : 'error';
                    break;
                case BuddyProgress.reject:
                    result = 'error';
                    break;
                case BuddyProgress.success:
                    result = 'checked';
                    break;
            }
            return result;
        },
        sqContentBody() {
            if (this.sqStatus !== BuddyProgress.process && this.sqStatus !== BuddyProgress.reject)
                return '';
            if (this.info === InfoBlock.apiCreatedAnalyzing)
                return '';
            if (this.info === InfoBlock.sqNoData)
                return this.$t('buddyPage.sqLowData');
            else
                return this.$t('buddyPage.sqLow');
        },
        testIcon() {
            let result = 'question';
            if (this.testingStatus === BuddyProgress.success)
                result = 'checked';
            if (this.currentStage === StagesNames.testing) {
                if (this.testingStatus === BuddyProgress.process)
                    result = 'question';
                if (this.testingStatus === BuddyProgress.reject)
                    result = 'error';
            }
            return result;
        },
        testContentBody() {
            let contentKey = '';
            if (this.currentStage === StagesNames.testing) {
                if (this.testingStatus === BuddyProgress.process)
                    contentKey = '';
                if (this.testingStatus === BuddyProgress.reject)
                    contentKey = 'testIndicators';
            }
            return contentKey ? this.$t(`buddyPage.${contentKey}`) : '';
        },
        passportDocs() {
            return getPassportUrl('/id/legal-information?buddy=true', { withAcceptor: true });
        },
        isUnplugged() {
            return this.status === BuddyStatus.unplugged;
        },
        showBuddyKey() {
            return !this.isInnerStatusHideApikey;
        },
        showBuddyApiKey() {
            return this.innerStatus === BuddyInnerStatus.test || this.innerStatus === BuddyInnerStatus.ready || this.innerStatus === BuddyInnerStatus.downSq || this.innerStatus === BuddyInnerStatus.downStrategy;
        },
        robotIconImagePostfix() {
            return this.status === BuddyStatus.active ? '-active' : '';
        },
        btnIconImage() {
            let icon = '';
            if (this.status === BuddyStatus.test)
                icon = 'cog';
            if (this.status === BuddyStatus.active)
                icon = 'checked';
            return icon;
        },
        infoBlock() {
            let title = '';
            let subtitle = '';
            // if (this.status === BuddyStatus.test) {
            //   title = 'testAsideInfoTitle'
            //   subtitle = 'testAsideInfoSubtitle'
            // }
            if (this.status === BuddyStatus.active) {
                title = 'activeAsideInfoTitle';
                subtitle = 'activeAsideInfoSubtitle';
            }
            return { title, subtitle };
        }
    },
    mounted() {
        this.getApiKeyInfo();
    }
});
